// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"62":"brand-rigging","155":"brand-danfloss","801":"brand-arg"}[chunkId] || chunkId) + "." + {"62":"f15d32a0","155":"78c28056","801":"d3a726e8","888":"0d2f255a"}[chunkId] + ".chunk.css";
};